/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Validation_Password_Label_LowercaseInputs */

const nl_validation_password_label_lowercase = /** @type {(inputs: Validation_Password_Label_LowercaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Een kleine letter`)
};

/**

* @param {Validation_Password_Label_LowercaseInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const validation_password_label_lowercase = /** @type {((inputs?: Validation_Password_Label_LowercaseInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Validation_Password_Label_LowercaseInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_validation_password_label_lowercase(inputs)
});
export { validation_password_label_lowercase as "validation.password.label_lowercase" }